module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/password-reset-cover-1c077ee70c82c9b96560fe47ff11210c.jpg";